const getNormalizedHeight = ({height, width, caption}) => {
    const IMAGE_WIDTH_ESTIMATE = 400;
    const CAPTION_HEIGHT_ESTIMATE = 25;
    // Guess height if not provided
    if (!height || !width) {
        return 200;
    }
    return (height * (IMAGE_WIDTH_ESTIMATE / width)) +
            (caption ? CAPTION_HEIGHT_ESTIMATE : 0);
};

const splitIntoTwoColumns = (images) => {
    // This function splits images into two columns,
    // trying to normalize the height.
    let columns = [[], []];
    let runningTotalColumnHeight = [0, 0];

    const addToColumn = (colIndex, image, normalizedHeight) => {
        columns[colIndex].push(image);
        runningTotalColumnHeight[colIndex] += normalizedHeight;
    };

    let defaultColumn = 0;

    // Go through each image. Place image in column with the
    // lowest current height. If same height, use `defaultColumn`.
    // Once image placed, set defaultColumn to the opposite
    // column, because default order is alternating.
    images.forEach((image) => {
        const otherColumn = defaultColumn === 0 ? 1 : 0;
        const normalizedHeight = getNormalizedHeight(image);
        if (runningTotalColumnHeight[defaultColumn] <=
            runningTotalColumnHeight[otherColumn]) {
            addToColumn(defaultColumn, image, normalizedHeight);
            defaultColumn = otherColumn;
        } else {
            addToColumn(otherColumn, image, normalizedHeight);
        }
    });
    return columns;
};

export {getNormalizedHeight, splitIntoTwoColumns};
